import React, { useState, useMemo } from"react";

const DepartureCalculator = ({ departure }) => {
 const pricing = departure?.pricing?.b2c || {};

 const [rooms, setRooms] = useState([
 { adults: 1, children2_6: 0, children6_12: 0, bebe: 0, thirdBed: 0, roomType:"double" }
 ]);

 const hasChildren = pricing.enf2_6 != null || pricing.enf6_12 != null || pricing.bebe != null;
 const hasRoomChoice = pricing.tarifdemidouble != null || pricing.spplementsingle != null;

 const total = useMemo(() => {
 return rooms.reduce((sum, room) => {
 let roomSum = 0;
 const base = pricing.price || 0;

 // Adultes
 if (!hasRoomChoice || room.roomType ==="double") {
 roomSum += base * room.adults;
 } else if (room.roomType ==="demi-double") {
 roomSum += (pricing.tarifdemidouble || 0) * room.adults;
 } else if (room.roomType ==="single") {
 roomSum += (base + (pricing.spplementsingle || 0)) * 1; // Always 1 adult
 }

 // Enfants
 roomSum += (pricing.enf2_6 || 0) * room.children2_6;
 roomSum += (pricing.enf6_12 || 0) * room.children6_12;
 roomSum += (pricing.bebe || 0) * room.bebe; // 🆕 ADD BEBE CALCULATION

 // 3ème lit
 roomSum += (pricing.tarif3eme || 0) * room.thirdBed;

 return sum + roomSum;
 }, 0);
 }, [rooms, pricing, hasRoomChoice]);

 const addRoom = () => {
 setRooms([...rooms, { adults: 1, children2_6: 0, children6_12: 0, bebe: 0, thirdBed: 0, roomType:"double" }]);
 };

 const removeRoom = (index) => {
 setRooms(rooms.filter((_, i) => i !== index));
 };

 return (
 <div className="mt-4 p-4 bg-light rounded border">
 <h6 className="fw-bold mb-3 text-primary">
 <i className="fa fa-calculator me-2"></i>Calculer votre prix
 </h6>

 {rooms.map((room, idx) => (
 <div key={idx} className="mb-3 p-3 border rounded position-relative">
 <h6>Chambre {idx + 1}</h6>
 {rooms.length > 1 && (
 <button
 type="button"
 className="btn btn-sm btn-danger position-absolute top-0 end-0 m-2"
 onClick={() => removeRoom(idx)}
 >
 Supprimer
 </button>
 )}
 <div className="row g-3 mt-2">
 {/* 1. Type de chambre */}
 {hasRoomChoice && (
 <div className="col-md-3">
 <label className="form-label">Type de chambre</label>
 <select
 className="form-select"
 value={room.roomType}
 onChange={(e) => {
 const value = e.target.value;
 const newRooms = [...rooms];
 newRooms[idx].roomType = value;
 if (value ==="single") newRooms[idx].adults = 1;
 setRooms(newRooms);
 }}
 >
 <option value="double">Double</option>
 {pricing.tarifdemidouble != null && <option value="demi-double">Demi-double</option>}
 {pricing.spplementsingle != null && <option value="single">Single</option>}
 </select>
 </div>
 )}
 {/* 2. Adulte */}
 <div className="col-md-3">
 <label className="form-label">Adulte</label>
 <input
 type="number"
 min="1"
 className="form-control"
 value={room.adults}
 disabled={room.roomType ==="single"}
 onChange={(e) => {
 const newRooms = [...rooms];
 newRooms[idx].adults = +e.target.value;
 setRooms(newRooms);
 }}
 />
 </div>
 {/* 3. 3ᵉ lit */}
 {pricing.tarif3eme != null && pricing.tarif3eme > 0 && (
 <div className="col-md-3">
 <label className="form-label">3ᵉ lit</label>
 <input
 type="number"
 min="0"
 className="form-control"
 value={room.thirdBed}
 onChange={(e) => {
 const newRooms = [...rooms];
 newRooms[idx].thirdBed = +e.target.value;
 setRooms(newRooms);
 }}
 />
 </div>
 )}
 {/* 4. Enfant 06-12 ans */}
 {pricing.enf6_12 != null && (
 <div className="col-md-3">
 <label className="form-label">Enfant 06-12 ans</label>
 <input
 type="number"
 min="0"
 className="form-control"
 value={room.children6_12}
 onChange={(e) => {
 const newRooms = [...rooms];
 newRooms[idx].children6_12 = +e.target.value;
 setRooms(newRooms);
 }}
 />
 </div>
 )}
 {/* 5. Enfant 02-06 ans */}
 {pricing.enf2_6 != null && (
 <div className="col-md-3">
 <label className="form-label">Enfant 02-06 ans</label>
 <input
 type="number"
 min="0"
 className="form-control"
 value={room.children2_6}
 onChange={(e) => {
 const newRooms = [...rooms];
 newRooms[idx].children2_6 = +e.target.value;
 setRooms(newRooms);
 }}
 />
 </div>
 )}
 {/* 6. Bébé moins 02 ans */}
 {pricing.bebe != null && (
 <div className="col-md-3">
 <label className="form-label">Bébé -02 ans</label>
 <input
 type="number"
 min="0"
 className="form-control"
 value={room.bebe}
 onChange={(e) => {
 const newRooms = [...rooms];
 newRooms[idx].bebe = +e.target.value;
 setRooms(newRooms);
 }}
 />
 </div>
 )}
 </div>
 </div>
 ))}

 <button className="btn btn-outline-primary mb-3" onClick={addRoom}>
 Ajouter une chambre
 </button>

 <div className="mt-4 text-center p-3 bg-white rounded border">
 <strong>Total à payer</strong>
 <h3 className="fw-bold text-success mt-2">{total.toFixed(0)} TND</h3>
 </div>
 </div>
 );
};

export default DepartureCalculator;